export const NAME_TITILE = ['welfare', 'day', 'android', 'ios', 'web'];



// WEBPACK FOOTER //
// ./src/common/js/uz.js